import { Ng2StateDeclaration } from '@uirouter/angular';
import * as fromInvoice from '.';
import { LoggingService } from '../../shared/services/logging/logging.service';

const log = new LoggingService();

export const InvoiceRenumberingRoute: Ng2StateDeclaration = {
    // name: 'invoice.**'
    name: 'invoice.renumbering',
    url: '/renumbering',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.invoiceModule)
    data: { requiresAuth: true },
    component: fromInvoice.InvoiceSessionNumberContainerComponent
};
